import React from 'react';
import { Shield } from 'lucide-react';

const insurances = [
  'Medicare',
  'Blue Cross Blue Shield',
  'Aetna',
  'Cigna',
  'United Healthcare',
  'Humana',
  'Tricare',
  'Workers Compensation',
];

export const InsuranceSection = () => {
  return (
    <section className="py-12 bg-gradient-trust border-y border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 text-primary mb-4">
            <Shield className="w-5 h-5" />
            <span className="text-sm font-semibold">Insurance Accepted</span>
          </div>
          <h3 className="font-display text-xl font-semibold text-foreground">
            We Accept Most Major Insurance Plans
          </h3>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {insurances.map((insurance) => (
            <span 
              key={insurance}
              className="px-4 py-2 bg-card text-foreground rounded-full text-sm font-medium shadow-sm border border-border"
            >
              {insurance}
            </span>
          ))}
        </div>
        <p className="text-center text-muted-foreground text-sm mt-6">
          Don't see your insurance? Contact us to verify coverage.
        </p>
      </div>
    </section>
  );
};

export default InsuranceSection;
